import logoInoxShipping from "../../images/inox_logo.png";
import iconInoxShipping from "../../images/inox_icon.png";
import { Image } from "react-bootstrap";
import USFlag from "../../images/flags/us.svg";
import ChineseFlag from "../../images/flags/china.svg";
import IndianFlag from "../../images/flags/in.svg";
import '../css/TopNavbar.css';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import * as actions from "../../actions/AuthActions";
import { persistor } from "../../store";
import { useState, useEffect, createContext } from "react";
import AllRoles from "../../images/all_roles.png";
import DepotIcon from "../../images/depot.png";
import { setPortLocation } from "../../store/locationSlice";
import NotificationBell from "./Notification";

export const LocationContext = createContext();

function TopNavbar(props) {
    const token = sessionStorage.getItem("token");

    console.log("")

    const dispatch = useDispatch();
    const profile = sessionStorage['profile_picture']
    const [currentUserRolePermissionData, setCurrentUserRolePermissionData] = useState([]);
    const [currentUser, setCurrentUser] = useState([]);
    const user_id = sessionStorage['id']
    const user_name = sessionStorage['name']
    const user_role = sessionStorage['userrole']
    const current_user_role = sessionStorage['currentRole']
    const [currentUserRoles, setCurrentUserRoles] = useState([]);
    const [currentUserDepot, setCurrentUserDepot] = useState([]);
    const [currentSelectedDepot, setCurrentSelectedDepot] = useState("All");
    const [currentUserPort, setCurrentUserPort] = useState([]);

    const currentSelectedPort = useSelector((state) => state.location.currentSelectedPort);

    const getCurrentUser = async (id) => {
        try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/user/'+id);
            if(response.data){
                setCurrentUser(response?.data)
                setCurrentUserPort(response?.data?.port_data)  
                setCurrentUserDepot(response?.data?.depot_data)
                
                const user_role_list = []
                for(let i=0;i<response.data.role_data.length;i++){
                    user_role_list.push(response.data.role_data[i].role)
                }
                
                setCurrentUserRoles(user_role_list)
            }
        } catch (err) {
            toast.error("Error in fetching user data! Try again.");
        }
      }

    const getCurrentUserRolePermission = async (roles) => {
        try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/role/getuserrolepermission?roles='+roles);
            
            const role_permissions_array = []
            for(let i=0; i<response.data.length; i++){
                for(let j=0; j<response?.data[i]?.permissions_array.length; j++){
                    if(!role_permissions_array.includes(response?.data[i]?.permissions_array?.[j])){
                        role_permissions_array.push(response?.data[i]?.permissions_array?.[j])
                    }
                }
            }

            if(role_permissions_array){
                setCurrentUserRolePermissionData(role_permissions_array)
            }
              
        } catch (err) {
            toast.error("Error in fetching user role data! Try again.");
        }
      }

    const getSelectedRolePermission = async (role_id) => {
        try {
            const response = await axios.get(process.env.REACT_APP_BACKEND_API_URL+'/user/role/'+role_id);
            setCurrentUserRolePermissionData(response?.data?.permissions_array)
            console.log("response?.data?.permissions_array", response?.data?.permissions_array)
        } catch (err) {
            toast.error("Error in fetching user role data! Try again.");
        }
    }

    const Logout = (data) => {
        return async (dispatch) => {
            try {
              const response = await axios.post(process.env.REACT_APP_BACKEND_API_URL+'/user/logout/', data, {
                  headers: {
                  "Content-Type": "application/json",
                  },
              });
    
              console.log("Response for logout:", response);
              if (response.status === 204) {
                  sessionStorage.clear();
                  dispatch(actions.logout());
                //   toast.success("You are successfully logged out.")
                  setTimeout(() => {
                    window.location.replace("/");
                  }, 1000);
              }
            } catch (err) {
              console.log("Error", err);
              dispatch(actions.logout());
              persistor.purge();
            }
        };
    };

    useEffect(() => {
        getCurrentUserRolePermission(user_role)
      }, [user_role]);

    useEffect(() => {
        getCurrentUser(user_id)
    }, [user_id]);

    const setCurrentSelectedRole = (role, role_name, role_icon) => {
        sessionStorage.setItem("currentRole", role)
        sessionStorage.setItem("currentRoleName", role_name)
        sessionStorage.setItem("currentRoleIcon", role_icon)
        if(role!="All"){
            getSelectedRolePermission(role)
        }
        else{
            getCurrentUserRolePermission(user_role)
        }

        props.sendDataToParent(currentUserRolePermissionData);
    }


    return (
        <div class="d-flex bd-highlight bg-light border-bottom" style={{ position: props.topNavbarStatic?'fixed':'relative', zIndex: 1000, width: '100%' }}>
            <div class="p-1 flex-grow-1 text-left bd-highlight">
                {props.sidebarCollapsed?
                <Image src={logoInoxShipping} height={50} className="float-left px-3"></Image>
                :
                <Image src={iconInoxShipping} height={50} className="float-left px-2"></Image>
                }
            </div>

            <div style={{display: 'None'}}>
                {currentUserRolePermissionData}
            </div>

            <NotificationBell authToken={token} />

            {
              currentUserRolePermissionData?.includes("setting:port:view")?
            <div class="bd-highlight">
                <div class="dropdown ms-sm-3 pt-3">
                    <button type="button" title="Location" class="btn text-inox-green px-0 border-0" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="d-flex align-items-center">
                            <span className="fa fa-globe fa-lg"></span>
                            <span className="quote-dropdown fw-bold"></span>
                        </span>
                    </button>

                    <div class="dropdown-menu custom-topnavbar-dropdown-menu dropdown-menu-end font-12px">
                        {currentUserPort?.length>0?
                            currentUserPort?.length>1?
                                <a class={`dropdown-item pointer ${currentSelectedPort=="All"?"bg-muted":""}`} onClick={() => dispatch(setPortLocation("All"))}>
                                    <i class="fa fa-globe text-muted fs-16 align-middle me-1"></i>
                                    <span class="align-middle px-2">All</span>
                                </a>
                            :
                            ""
                        :
                            <span class="align-middle px-3">No Ports Assigned</span>
                        }

                        {currentUserPort?.map(location => (
                            <a class={currentSelectedPort==location.id?"dropdown-item pointer bg-muted":"dropdown-item pointer"} onClick={() => dispatch(setPortLocation(location.id))}>
                                <i class="fa fa-globe text-muted fs-16 align-middle me-1"></i>
                                <span class="align-middle px-2">{location.name}</span>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
            :
            ""
            }

            {
              currentUserRoles?.includes("depotuser")?
                <div class="bd-highlight">
                    <div class="dropdown ms-sm-3 pt-3">
                        <button type="button" title="Location" class="btn text-inox-green px-0 py-0 border-0" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="d-flex align-items-center">
                                <img src={DepotIcon} height={20} width={20}></img>
                                <span className="quote-dropdown fw-bold"></span>
                            </span>
                        </button>

                        <div class="dropdown-menu custom-topnavbar-dropdown-menu dropdown-menu-end font-12px">
                            {currentUserDepot?.length>0?
                                currentUserDepot?.length>1?
                                    <a class={`dropdown-item pointer ${currentSelectedPort=="All"?"bg-muted":""}`}>
                                        <img src={DepotIcon} height={20} width={20}></img>
                                        <span class="align-middle px-3">All</span>
                                    </a>
                                :
                                    ""
                            :
                                <span class="align-middle px-3">No Depot Assigned</span>
                            }

                            {currentUserDepot?.map(depot => (
                                <a class={currentSelectedDepot==depot.id?"dropdown-item pointer bg-muted":"dropdown-item pointer"} onClick={() => setCurrentSelectedDepot(depot.id)}>
                                    <img src={DepotIcon} height={20} width={20}></img>
                                    <span class="align-middle px-3">{depot.name}</span>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
                :
                ""
            }

            {
            currentUserRolePermissionData?.includes("setting:currency:view")?
            <div class="bd-highlight">
                <div class="dropdown ms-sm-3 pt-3">
                    <button type="button" title="Currency" class="btn text-inox-green px-0 border-0" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="d-flex align-items-center">
                            <span className="fa fa-money fa-lg"></span>
                            <span className="quote-dropdown fw-bold"></span>
                        </span>
                    </button>

                    <div class="dropdown-menu custom-topnavbar-dropdown-menu dropdown-menu-end">
                        <a class="dropdown-item" href="pages-profile.html">
                            <i class="fa fa-rupee text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle px-2">Indian Rupee</span>
                        </a>

                        <a class="dropdown-item" href="pages-faqs.html">
                            <i class="fa fa-dollar text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle px-2">US Dollar</span>
                        </a>

                        <a class="dropdown-item" href="pages-faqs.html">
                            <i class="fa fa-yen text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle px-2">Chinese Yuan</span>
                        </a>

                        <a class="dropdown-item" href="pages-faqs.html">
                            <i class="fa fa-gbp text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle px-2">British Pound</span>
                        </a>
                    </div>
                </div>
            </div>
            :
            ""
            }

            {
            currentUserRolePermissionData?.includes("setting:language:view")?
            <div class="bd-highlight">
                <div class="dropdown ms-sm-3 pt-3" style={{ paddingRight: '1rem'}}>
                    <button type="button" title="Language" class="btn text-inox-green px-0 border-0" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="d-flex align-items-center">
                            <span className="fa fa-language fa-lg"></span>
                        </span>
                    </button>

                    <div class="dropdown-menu custom-topnavbar-dropdown-menu dropdown-menu-end">
                        <a class="dropdown-item" href="pages-profile.html">
                            <Image src={USFlag} width={15} />
                            <span class="align-middle px-3">English</span>
                        </a>

                        <a class="dropdown-item" href="pages-faqs.html">
                            <Image src={ChineseFlag} width={15} />
                            <span class="align-middle px-3">Mandarin</span>
                        </a>

                        <a class="dropdown-item" href="pages-faqs.html">
                            <Image src={IndianFlag} width={15} />
                            <span class="align-middle px-3">Hindi</span>
                        </a>
                    </div>
                </div>
            </div>
            :
            ""
            }

            <div class="px-1 bd-highlight">
                <div class="dropdown pt-1">
                    <button type="button" class="btn p-0 border-0" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="d-flex align-items-center">
                            <span class="">
                                <span class="d-xl-inline-block pt-1">
                                    <img src={sessionStorage['currentRoleIcon']} height={37} width={37} className="role-img p-2" title={sessionStorage['currentRoleName']}></img>
                                </span>
                            </span>
                        </span>
                    </button>

                    <div class="dropdown-menu custom-topnavbar-dropdown-menu dropdown-menu-end font-12px">
                        {currentUser?.role?.length > 1 ?
                            <a class={sessionStorage['currentRole'] == "All"?"dropdown-item pointer border-bottom bg-muted":"dropdown-item pointer border-bottom"}
                            onClick={() => setCurrentSelectedRole("All", "All Roles", AllRoles)}>
                                <img src={AllRoles} height={20} width={20} className="role-img"></img>
                                <span class="align-middle px-4">All Roles</span>
                            </a>
                            :
                            ""
                        }

                        {currentUser?.role_data?.map(role => (
                        <a class={sessionStorage['currentRole'] == role.id?"dropdown-item pointer bg-muted":"dropdown-item pointer"}
                        onClick={() => setCurrentSelectedRole(role.id, role.role_name, role.role_icon)}>
                            <img src={role.role_icon} height={20} width={20} className="role-img"></img>
                            <span class="align-middle px-4">{role.role_name}</span>
                        </a>
                        ))}
                    </div>
                </div>
            </div>

            <div class="px-1 bd-highlight">
                <div class="dropdown pt-1" style={{ paddingRight: '1rem' }}>
                    <button type="button" class="btn p-0 border-0" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="d-flex align-items-center">
                            <span class="">
                                {profile!="null"?
                                <span class="d-xl-inline-block pt-1">
                                    <img src={profile} height={40} width={40} className="profile-picture-circle"></img>
                                </span>
                                :
                                <span class="d-xl-inline-block ms-1 fw-bold profile-circle pt-2 text-white font-16">
                                    {user_name.charAt(0).toUpperCase()}
                                </span>
                                }
                            </span>
                        </span>
                    </button>

                    <div class="dropdown-menu custom-topnavbar-dropdown-menu dropdown-menu-end">
                        <h6 class="dropdown-header">Welcome {user_name}</h6>
                        <a class="dropdown-item" href="/dashboard">
                            <i class="fa fa-cog text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle px-2">Settings</span>
                        </a>

                        <a class="dropdown-item" href="pages-faqs.html">
                            <i class="fa fa-life-ring text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle px-2">Contact Support</span>
                        </a>

                        <div class="dropdown-divider"></div>

                        <a class="dropdown-item pointer" onClick={() => dispatch(Logout())}>
                            <i class="fa fa-sign-out text-muted fs-16 align-middle me-1"></i>
                            <span class="align-middle px-2" data-key="t-logout">Logout</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TopNavbar;
